import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-termo-privacidade',
  templateUrl: './modal-termo-privacidade.component.html',
  styleUrls: ['./modal-termo-privacidade.component.scss', './modal-termo.scss']
})
export class ModalTermoPrivacidadeComponent implements OnInit {

  mdbRef: MDBModalRef

  constructor(
    public modalRef: MDBModalRef,
  ) { }

  model: any
  textoTermo: string
  cssTermo: string

  ngOnInit(): void {
    this.textoTermo = this.model[0].arquivoTexto
  }
  downloadPdf(base64String){
    const linkSource = 'data:application/pdf;base64,' + `${base64String}`;
    const downloadLink = document.createElement("a");
    const fileName = "Termo-Politica-Privacidade-FGC.pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  closeModal(){
    return this.modalRef.hide()
  }
}
